import React from 'react';
import SkeletonBar from '../Skeleton/SkeletonBar';

/**
 * Skeleton table body rows — keeps table height stable during loading.
 * @param {number} rows
 * @param {string[]} cellWidths - Tailwind width classes per column
 */
export default function TableBodySkeleton({ rows = 10, cellWidths = [] }) {
  const colCount = cellWidths.length || 4;
  const widths =
    cellWidths.length > 0
      ? cellWidths
      : Array.from({ length: colCount }, () => 'w-full max-w-[8rem]');

  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={`skeleton-row-${rowIndex}`} className="border-b border-dark-border last:border-0">
          {widths.map((widthClass, colIndex) => (
            <td key={`skeleton-cell-${rowIndex}-${colIndex}`} className="py-3 px-4">
              <SkeletonBar className={`h-4 ${widthClass}`} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
